import {getData, LOGIN} from "../storage";
import {isEmpty, vuepayAlert} from "../utility";

export const joinBroadcastError = (payload, data, props) => {

    getData(LOGIN)
        .then((data) => {

            if (!isEmpty(data)) {
                //You have to be login to perform the below action
                if (payload.hasOwnProperty("error_code")) {
                    switch (payload.error_code) {
                        case 1000:
                            //When user killed the app after successful sign up not providing mobile number
                            props.history.push("/verify-mobile", {
                                phone_number_validated: false,
                                api_token: data.api_token,
                                token: data.token,
                                parentPath: {
                                    basePath: props.history.location.pathname,
                                    search: props.history.location.search
                                }
                            })
                            break;
                        case 1001:
                            //When user killed the app after registering their mobile number but didn’t do 2FA (Show change mobile number)
                            props.history.push("/verify-otp", {
                                country_code: data.country_code,
                                mobile_number: data.phone_number,
                                phone_number_validated: false,
                                api_token: data.api_token,
                                token: data.token,
                                parentPath: {
                                    basePath: props.history.location.pathname,
                                    search: props.history.location.search
                                }
                            });
                            break;
                        case 1002:
                            //When user killed the app without doing 2FA after login (Don’t show change mobile number)
                            props.history.push("/verify-otp", {
                                country_code: data.country_code,
                                mobile_number: data.phone_number,
                                phone_number_validated: true,
                                api_token: data.api_token,
                                token: data.token,
                                parentPath: {
                                    basePath: props.history.location.pathname,
                                    search: props.history.location.search
                                }
                            });
                            break;
                    }
                } else {
                    //Just show error can't run any condition
                    vuepayAlert("error", payload.message);
                }
            }

        })
}